import './library/bootstrap-3.4.1';
import './library/app';
import './library/jquery-ui-1_11_2.min'; // for consistency prior to JQuery UI upgrade
import './library/plugins';

import '../styles/ca-pro-ui/ca-bootstrap.css';
import '../styles/ca-pro-ui/ca-main.min.css';
import '../styles/ca-pro-ui/ca-plugins.min.css';
import '../styles/ca-pro-ui/ca-pro-ui.css';
import '../styles/ca-pro-ui/ca-pro-ui-corrections.css';
import '../styles/ca-pro-ui/bootstrap-multiselect.css';
